import { useCallback, useState } from "react";
import { AnimatePresence } from "framer-motion";
import { Splash } from "../components/Splash";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Collaboration } from "../components/Collaboration";
import { ActionList } from "../components/ActionList";
import { ShareSection } from "../components/ShareSection";
import { Disclaimer } from "../components/Disclaimer";
import { Seo } from "../components/Seo";
import { useLang } from "../i18n/LanguageContext";

const HOME_DESC = {
  it: "SYNrise, hub ufficiale del progetto Rinasci. Evolvi. Investi.: eToro, canale Telegram free, Instagram, sito e Trustpilot. In collaborazione con Be Five% e RiseVision.",
  en: "SYNrise, the official hub of the Rinasci. Evolvi. Investi. project: eToro, free Telegram channel, Instagram, website and Trustpilot. With Be Five% and RiseVision.",
  es: "SYNrise, el hub oficial del proyecto Rinasci. Evolvi. Investi.: eToro, canal gratuito de Telegram, Instagram, web y Trustpilot. Con Be Five% y RiseVision.",
};

export default function Home() {
  const [ready, setReady] = useState(false);
  const done = useCallback(() => setReady(true), []);
  const { lang } = useLang();

  return (
    <>
      <Seo title="SYNrise — Rinasci. Evolvi. Investi." description={HOME_DESC[lang]} path="/" lang={lang} />
      <AnimatePresence>{!ready && <Splash onDone={done} />}</AnimatePresence>
      <Header />
      <main>
        <Hero ready={ready} />
        <Marquee />
        <div className="mx-auto grid max-w-6xl gap-20 px-5 py-20 sm:px-8 sm:py-28 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              <Collaboration />
            </div>
          </div>
          <div className="lg:col-span-7">
            <ActionList />
          </div>
        </div>
        <div className="mx-auto max-w-6xl px-5 pb-24 sm:px-8">
          <ShareSection />
        </div>
      </main>
      <Disclaimer />
    </>
  );
}
